/**
 * NoBrands.jsx
 * Shown by every screen that cannot work without a brand.
 *
 * It takes the load error as well as the list, because the two cases look
 * identical from an empty array and must not read the same: "you have no
 * brands" sent someone hunting for missing data when the real answer was that
 * the request had failed. And the icon here used to be the only thing on the
 * screen resembling a button, while doing nothing — so there is now a real
 * one.
 */

import { useNavigate } from 'react-router-dom';
import { Plus, Warning } from './Icons.jsx';

export default function NoBrands({ error, what = 'A post needs a brand to publish as.' }) {
  const navigate = useNavigate();

  if (error) {
    return (
      <div className="card">
        <div className="empty">
          <div className="empty__art empty__art--warn">
            <Warning size={30} />
          </div>
          <h3>Could not load your brands</h3>
          <p>{error.message}</p>
          <button className="btn btn--primary" onClick={() => window.location.reload()}>
            Try again
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="card">
      <div className="empty">
        <div className="empty__art">
          <Plus size={30} />
        </div>
        <h3>Add a brand first</h3>
        <p>{what}</p>
        <button className="btn btn--primary" onClick={() => navigate('/brands')}>
          <Plus /> Go to Brands
        </button>
      </div>
    </div>
  );
}
